import React, { useContext, useRef } from 'react';
import c from './shortcuts.module.scss';
import preview from './assets/preview.png';
import empty from './assets/empty.svg';
import WidgetIcon from '../../widget-library/WidgetIcon';
import { Button, Icon, useResponsiveValue } from '@monash/portal-react';
import { WidgetContext } from '@/components/providers/WidgetProvider';
import EditShortcutsDesktop from './edit-shortcuts-desktop/EditShortcutsDesktop';
import EditShortcutsMobile from './edit-shortcuts-mobile/EditShortcutsMobile';
import Shortcut from './shortcut/Shortcut';

const Shortcuts = ({
  widgetId,
  data,
  updateData,
  escapeSettingActionsFocusRef,
}) => {
  const BREAKPOINTS = [
    {
      mq: '(max-width: 459px)',
      value: 'mobile',
    },
    {
      mq: '(min-width: 460px)',
      value: 'desktop',
    },
  ];
  const format = useResponsiveValue(BREAKPOINTS);
  const isMobile = format === 'mobile';

  const shortcuts = Array.isArray(data?.shortcuts) ? data?.shortcuts : [];

  const { setEditActiveWidget, editActiveWidget } = useContext(WidgetContext);
  const shouldDisplayURL = data?.display?.find((id) => id === 'url');
  const editShortcutsButtonRef = useRef();

  return (
    <div className={c.shortCuts}>
      {editActiveWidget === widgetId &&
        (isMobile ? (
          <EditShortcutsMobile
            updateData={updateData}
            currentShortcuts={shortcuts}
            escapeFocusRef={escapeSettingActionsFocusRef}
          />
        ) : (
          <EditShortcutsDesktop
            updateData={updateData}
            currentShortcuts={shortcuts}
            escapeFocusRef={escapeSettingActionsFocusRef}
          />
        ))}

      {shortcuts?.length ? (
        <div className={c.shortcutsList}>
          {shortcuts.map((shortcut) => (
            <Shortcut
              key={shortcut.id}
              shortcut={shortcut}
              shouldDisplayURL={shouldDisplayURL}
            />
          ))}
        </div>
      ) : (
        <div className={c.emptyShortcutsWrapper}>
          <div
            className={c.emptyShortcuts}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <div className={c.graphic}>
              <img src={empty} alt="" />
              <h3>No shortcuts yet</h3>
            </div>
            <div className={c.editShortcuts}>
              <Button
                ref={editShortcutsButtonRef}
                variant="text"
                size="small"
                icon={<Icon.Pencil />}
                onClick={() => {
                  setEditActiveWidget(widgetId);
                }}
                mode="card"
              >
                Add/Edit shortcuts
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ShortcutsModule = {
  component: Shortcuts,
  name: 'Shortcuts',
  icon: WidgetIcon.Shortcuts,
  previewImage: preview,
  previewBackgroundColor: '#FEE2E2',
  description: 'Keep all the links you use most – all in one place.',
  additionalOptions: [
    {
      key: 'shortcuts',
      editType: null,
      default: [],
    },
    {
      key: 'display',
      name: 'Display',
      editType: 'checkbox',
      default: [],
      options: [{ id: 'url', name: 'URL' }],
    },
    {
      key: 'name',
      name: 'Name',
      editType: 'text',
      default: 'Shortcuts',
    },
  ],
  additionalActions: ({ setEditActiveWidget }) => [
    {
      action: ({ widgetId }) => {
        setEditActiveWidget(widgetId);
      },
      icon: <Icon.Pencil size={20} />,
      text: 'Add/Edit shortcuts',
    },
  ],
};

export default ShortcutsModule;
